import Slider from "@material-ui/core/Slider";
import { useTheme, withStyles } from "@material-ui/styles"
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import config from "../../../../config";
import { convertJSONToObject } from "../../../../utils";
import sliderThump from "./assets/slider-thump.svg";

function AirbnbThumbComponent(props) {
  return (
    <span {...props}>
      <img src={sliderThump} className="bar" alt=""/>
    </span>
  );
}

export default function Sliders({ handleSaveAnalyseTonality}) {

  const {t} = useTranslation();
  const { theme: { bgColors, colors, borderColors } } = useTheme()
  const theme = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isWhite = theme === config.THEMES_MODES.CONTRAST_LIGHT
  const isDark = theme === config.THEMES_MODES.CONTRAST_DARK
  const storageAnalyseTonality = convertJSONToObject(
    useSelector(state => state.userData?.user?.user_options?.analyse_tonality),
    config.defaultAnalyseTonality);

  const AirbnbSlider = React.useMemo(() => withStyles({
    root: {
      height: 5,
      padding: '13px 0',
      '& span:nth-child(4), & span:nth-child(8)': {
        display: 'none'
      }
    },
    thumb: {
      height: 14,
      width: 28,
      border: `2px solid ${borderColors.borderPrimary100}`,
      backgroundColor: isDark ? colors.colorPrimary600 : colors.colorProgress120,
      marginTop: -5,
      marginLeft: -13,
      borderRadius: '4px',
      boxShadow: '#999999 0 0 2px',
      '&:focus, &:hover, &$active': {
        boxShadow: `${colors.colorPrimary200} 0 2px 2px 1px`
      },
      '& .bar': {
        height: 7,
        width: '100%'
      }
    },
    active: {},
    track: {
      height: 5,
    },
    mark: {
      height: '5px',
      backgroundColor: colors.colorText,
      width: '1px'
    },
    rail: {
      backgroundColor: isWhite ? bgColors.bgPrimary900 : bgColors.bgPrimary300,
      opacity: 1,
      height: 5
    }
  })(Slider), [bgColors, colors])

  return (
    <div className={`d-flex flex-column mt-2 pt-2`} style={{ width: "50%"}}>
      {Object.entries(config.tonalityParameters).map(([key, val]) => (
        <div
          key={`div-${key}`}
          style={{
            display: "grid",
            gridTemplateColumns: "0.5fr 2fr 0.5fr",
            justifyItems: "end",
            gap: "0.85rem",
          }}
        >
          <p className="mr-3">{t(val.scaleFrom[1])}</p>
          <AirbnbSlider
            onChangeCommitted={(_event, value) =>
            handleSaveAnalyseTonality(key, value)}
            key={key}
            name={key}
            track={false}
            value={storageAnalyseTonality[key]}
            valueLabelDisplay="off"
            marks
            min={val.scaleFrom[0]}
            max={val.scaleTo[0]}
            ThumbComponent={AirbnbThumbComponent}
            step={Math.round((val.scaleTo[0] - val.scaleFrom[0]) / 4)}
            aria-label={t(key)}
          />
          <p className="ml-3">{t(val.scaleTo[1])}</p>
        </div>
      ))}
      <br />
    </div>
  );
}